/**
 * Created by vladislav on 22.07.2022
 */

const PersonsLibrary = function () {
    this.data = {};

    Object.keys(cleverapps.config.persons).forEach(function (group) {
        Object.keys(cleverapps.config.persons[group]).forEach(function (role) {
            const name = cleverapps.config.persons[group][role];

            this.add(role, {
                name,
                bundle: `persons_${group}`,
                json: bundles[`person_${role}`].jsons[`${role}_json`]
            });

            if (bundles[`person_${role}`] === undefined && cleverapps.config.debugMode) {
                throw `No person for role: ${role}`;
            }
        }, this);
    }, this);

    Object.keys(cleverapps.config.personsMinimal).forEach((role) => {
        if (!bundles[`person_minimal_${role}`] && cleverapps.config.debugMode) {
            throw `No minimalPerson for role: ${role}`;
        }
    });
};

PersonsLibrary.prototype.getData = function () {
    const roles = Object.keys(this.data);
    const data = {};

    roles.forEach((role) => {
        data[role] = this.getRole(role);
    });

    return data;
};

PersonsLibrary.prototype.add = function (role, person) {
    this.data[role] = person;
};

PersonsLibrary.prototype.choose = function (person1, person2) {
    if (typeof person1 === "string") {
        person1 = { role: person1 };
    }
    if (typeof person2 === "string") {
        person2 = { role: person2 };
    }

    if (person1 && this.data[person1.role] !== undefined) {
        return person1;
    }

    if (person2 && this.data[person2.role] !== undefined) {
        return person2;
    }

    return undefined;
};

PersonsLibrary.prototype.getRole = function (role) {
    const skin = cleverapps.skins.getSlot("getPerson") || "";

    if (skin) {
        if (!bundles[`person_${role}${skin}`] || !bundles[`person_${role}${skin}`].jsons) {
            return this.data[role];
        }

        return {
            name: this.data[role].name,
            bundle: this.data[role].bundle + skin,
            json: bundles[`person_${role}${skin}`].jsons[`${role}_json`] || bundles[`person_${role}${skin}`].jsons[`${role}${skin}_json`]
        };
    }
    return this.data[role];
};

PersonsLibrary.prototype.getVerticalDialogueJson = function (role) {
    return bundles["vertical_dialogue"] && bundles["vertical_dialogue"].jsons[`${role}_vertical_dialogue_json`];
};

PersonsLibrary.prototype.getMinimalJson = function (role) {
    return bundles[`person_minimal_${role}`] && bundles[`person_minimal_${role}`].jsons[`${role}_minimal_json`];
};